import Swiper from '../../node_modules/swiper/js/swiper';

new Swiper('.swiper-fv', {
  loop: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true,
  },
});
